import { useState } from 'react';
import { Box, Alert, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useAuth } from '../../context/authContext';
import { viewRootTextPrimarySx } from '../../util/chartTheme';
import DashboardView from '../Dashboard/DashboardView';

const PRIVATE_DEVICE_DISMISS_KEY = 'welcomePrivateDeviceNoticeDismissed';

export default function Welcome() {
  const { isPrivateDevice } = useAuth();
  // Dismissal is intentionally per-device (localStorage), not per-user: the
  // notice is about the device the user happens to be on.
  const [noticeDismissed, setNoticeDismissed] = useState(
    () => localStorage.getItem(PRIVATE_DEVICE_DISMISS_KEY) === 'true'
  );

  const dismissNotice = () => {
    localStorage.setItem(PRIVATE_DEVICE_DISMISS_KEY, 'true');
    setNoticeDismissed(true);
  };

  return (
    <Box
      sx={{
        ...viewRootTextPrimarySx,
        width: '100%',
        maxWidth: 1400,
        mx: 'auto',
        px: { xs: 1.5, sm: 2.5, md: 3 },
        pt: { xs: 2, sm: 3 },
        pb: 6,
      }}
    >
      {isPrivateDevice && !noticeDismissed && (
        <Alert
          severity='warning'
          sx={{ mb: 2.5, textAlign: 'left' }}
          action={
            <IconButton
              aria-label='Hinweis ausblenden'
              color='inherit'
              size='small'
              onClick={dismissNotice}
            >
              <CloseIcon fontSize='inherit' />
            </IconButton>
          }
        >
          <Typography variant='subtitle2' sx={{ fontWeight: 600 }}>
            Hinweis: privates Gerät
          </Typography>
          <Typography variant='body2'>
            Da du dich von einem privaten Gerät anmeldest, können deine Rechte und Menüoptionen
            eingeschränkt sein. Falls es sich doch um ein Firmengerät handelt, wende dich bitte an die
            IT-Abteilung.
          </Typography>
        </Alert>
      )}

      <DashboardView />
    </Box>
  );
}
